<template>
  <div class="sidebar-area">
    <div class="logo position-relative">
      <RouterLink
        to="/dashboard"
        class="d-block text-decoration-none position-relative"
      >
        <img src="@/assets/images/logo-icon.png" alt="logo-icon" style="max-width:20px" />
        <span class="logo-text fw-bold text-dark" style="font-size:20px; top:0;">SmartRate</span>
      </RouterLink>
      <button
        class="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
        id="sidebar-burger-menu"
        @click="stateStoreInstance.onChange"
      >
        <i data-feather="x"></i>
      </button>
    </div>

    <div class="layout-menu menu-vertical menu hover-scroll-bar">
      <ul class="menu-inner">
        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">Forfettari</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/dashboard" class="menu-link" @click="closeSidebarOnMobile">
            <span class="material-symbols-outlined menu-icon">dashboard</span>
            <span class="title">Dashboard</span>
          </RouterLink>
        </li>

        <li class="menu-item">
          <RouterLink to="/calcolo/forfettario" class="menu-link" @click="closeSidebarOnMobile">
            <span class="material-symbols-outlined menu-icon">calculate</span>
            <span class="title">Calcola Rata</span>
          </RouterLink>
        </li>




       </ul>
    </div>

    <!-- Version Info -->
    <div class="sidebar-version text-center mt-auto p-3" :class="{ 'd-none': isProduction }">
      <small class="text-muted" style="font-size: 9px;">V{{ appVersion }}</small>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from "vue";
import feather from "feather-icons";
import stateStore from "@/utils/store";

export default defineComponent({
  name: "LeftSidebar",
  setup() {
    const stateStoreInstance = stateStore;

    // Reactive state to track which menu items are open
    const openMenu = ref(null);

    // Check if we're in production environment
    const isProduction = computed(() => {
      return process.env.NODE_ENV === 'production';
    });

    // Get app version from environment variables
    const appVersion = computed(() => {
      return process.env.VUE_APP_VERSION;
    });

    // Method to toggle the menu items
    const toggleMenu = (menu) => {
      // If the same menu is clicked, toggle it; otherwise, open the clicked menu
      openMenu.value = openMenu.value === menu ? null : menu;
    };

    // Method to check if a menu is open
    const isOpen = (menu) => {
      return openMenu.value === menu;
    };

    // Method to close sidebar on mobile when menu item is clicked
    const closeSidebarOnMobile = () => {
      // Check if we're on mobile (when sidebar is in overlay mode)
      if (stateStoreInstance.open) {
        stateStoreInstance.onChange();
      }
    };

    onMounted(() => {
      feather.replace();
    });

    return {
      stateStoreInstance,
      toggleMenu,
      isOpen,
      closeSidebarOnMobile,
      isProduction,
      appVersion,
    };
  },
});
</script>

<style scoped>
.sidebar-area {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom:0;
}

.layout-menu {
  flex: 1;
  overflow-y: auto;
}

.sidebar-version {
  margin-top: auto;
  border-top: 1px solid #f0f0f0;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>
